module.exports = __webpack_public_path__ + "img/jumpsuits.2506b708.png";